export const PURGE_AUTH = "logout";
export const SET_AUTH = "setUser";
